import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { HampersItemComponent } from '../hampers-item/hampers-item.component';

interface RawItem {
  promotion_detail_id: number | string;
  product_id: string; // "p01;p02"
  // bisa ada properti lain
  selected_product?: string; // opsional: nilai awal yang terpilih
}

interface ProductOption {
  product_id: string;
  isChecked: boolean;
}

interface PromotionGroup {
  promotion_detail_id: number | string;
  products: ProductOption[];
}
@Component({
  selector: 'app-hampers',
  templateUrl: './hampers.component.html',
  styleUrls: ['./hampers.component.scss'],
})


export class HampersComponent implements OnInit {

  @Input() hamperList: any[];
  @Input() selectedHampers:any[];
  @Input() mstProductList :any[];
  @Input() productGimmickList :any[];
  @Input() regulerStock :any[];
  @Input() promoStock :any[];

  // data yang sudah dikelompokkan untuk template
  promotionGroups: PromotionGroup[] = [];
  productList: any[] = [];

  hampersId:any=0;
  selectableItem:any=[];
  selectableFreeItem:any=[];
  constructor(
    private modalController:ModalController
  ) { }

  ngOnInit() {
    this.productList = this.selectedHampers
  }

  async dismissModal() {
    await this.modalController.dismiss('');
  }

  async openHamperItems(hampersId:any,action:any,index:any) {
    const modal = await this.modalController.create({
      component: HampersItemComponent,
      componentProps: {
        hampersId:hampersId,
        action:action,
        hamperList:this.hamperList,
        mstProductList:this.mstProductList,
        productGimmickList:this.productGimmickList,
        selectedHampers:this.productList,
        index:index,
        regulerStock:this.regulerStock,        
        promoStock:this.promoStock
      },
      backdropDismiss: false
    });
    modal.onDidDismiss().then((modelData) => {
      if (modelData.data !== '') {
        if(action=='e'){
          let checkItemPcode = this.productList[index];
          if (checkItemPcode === undefined) {
            this.productList.push({
              hamper_code:modelData.data.hampersCode,
              id:modelData.data.hampersId,
              product_name:modelData.data.hampersName,
              qty:modelData.data.hampersQty,
              product_list:modelData.data.productList,
              price:modelData.data.hampersPrice,
              index:index
            });
          }
          else{
            checkItemPcode.product_name=modelData.data.hampersName;
            checkItemPcode.qty=modelData.data.hampersQty;
            checkItemPcode.product_list=modelData.data.productList;
            checkItemPcode.index=modelData.data.index;
            checkItemPcode.price=modelData.data.hampersPrice;
          }
        }
        else if(action=='a'){
          this.productList.push({
            hamper_code:modelData.data.hampersCode,
            id:modelData.data.hampersId,
            product_name:modelData.data.hampersName,
            qty:modelData.data.hampersQty,
            product_list:modelData.data.productList,
            price:modelData.data.hampersPrice,
            index:index
          });
        }
      }
    })
    return await modal.present();
  }
  deleteItem(index: any) {
    this.productList.splice(index, 1);
  }
  
  async chooseHamper() {
    let data = {
      productList:this.productList
    }
    await this.modalController.dismiss(data);
  }
}